module.exports = __webpack_public_path__ + "static/media/05.209263f4.jpg";